module.exports = "<p>adminsuperbranch works!</p>\n"